import { render, staticRenderFns } from "./ControlFechaTexto.vue?vue&type=template&id=60205060&scoped=true&"
import script from "./ControlFechaTexto.vue?vue&type=script&lang=js&"
export * from "./ControlFechaTexto.vue?vue&type=script&lang=js&"
import style0 from "./ControlFechaTexto.vue?vue&type=style&index=0&id=60205060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60205060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
